import { AddonManagement } from 'components/AddonManagement/AddonManagement';

export default AddonManagement;
